import { render, staticRenderFns } from "./recheckList.vue?vue&type=template&id=2e35a984&scoped=true"
import script from "./recheckList.vue?vue&type=script&lang=js"
export * from "./recheckList.vue?vue&type=script&lang=js"
import style0 from "./recheckList.vue?vue&type=style&index=0&id=2e35a984&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e35a984",
  null
  
)

export default component.exports